import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useOfferingSessionRuleSets = (offeringId) => {
  const urlStr = `${getApiUrl()}/offering-session-rule-set?offeringId=${offeringId}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const useOfferingSessionRuleSet = (id) => {
  const urlStr = `${getApiUrl()}/offering-session-rule-set/${id}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const usePostOfferingSessionRuleSet = () => {
  const postOfferingSessionRuleSet = async (payload) => {
    try {
      const url = `${getApiUrl()}/offering-session-rule-set`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postOfferingSessionRuleSet;
};

export const usePutOfferingSessionRuleSet = () => {
  const putOfferingSessionRuleSet = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/offering-session-rule-set/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return putOfferingSessionRuleSet;
};

export const useDeleteOfferingSessionRuleSet = () => {
  const deleteOfferingSessionRuleSet = async (id) => {
    try {
      const url = `${getApiUrl()}/offering-session-rule-set/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return deleteOfferingSessionRuleSet;
};
